import classNames from 'classnames';
import React from 'react';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import DetailsListSkeletonItem from './DetailsListSkeletonItem';
import { DetailsListItemProps } from './types';
import { useDetailsListContext } from './useDetailsListContext';

function defaultFormatter<TValue = string>(value: TValue) {
    return String(value);
}

function DetailsListItem<TValue = string>({
    show = true,
    value,
    formatter = defaultFormatter,
    label,
    placeholder,
    button,
    icon,
    className,
    dataTrackId,
    dataTrackLinkname,
    ...rest
}: DetailsListItemProps<TValue>) {
    const context = useDetailsListContext();
    if (!show) return null;

    if (context.isLoading) {
        return <DetailsListSkeletonItem />;
    }

    return (
        <div className={classNames('sgw-details-list__item', className)} {...rest}>
            <dt className="sgw-details-list__item-label">{label}</dt>

            <dd
                className={classNames('sgw-details-list__item-value', {
                    'with-icon-button': !!button?.onClick,
                    empty: !value,
                })}
            >
                <span>{value ? formatter(value) : placeholder}</span>
                {button && (
                    <IconButton
                        className="sgw-details-list__item-icon-button"
                        icon={icon ?? IconTypes.SLETT_24}
                        onClick={button.onClick}
                        screenReaderText={button.title}
                        data-track-id={dataTrackId}
                        data-track-linkname={dataTrackLinkname}
                    />
                )}
            </dd>
        </div>
    );
}

export default DetailsListItem;
